import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { useToast } from '@context/ToastContext';

import { datadogLogger } from '@helpers/datadogLogger';

import { useIsAuthNew } from '@hooks/useIsAuthNew';

import { getTranslationsState } from '@redux/selectors';
import { getIsRtlState } from '@redux/selectors';

const AuthObserver = () => {
  const { isAuthNew, login, auth } = useIsAuthNew();
  const [search, setSearchParams] = useSearchParams();
  const searchParams = new URLSearchParams(search);
  const { showToast } = useToast();
  const translations = useSelector(getTranslationsState);
  const isRtl = useSelector(getIsRtlState);
  const reAuthenticate = searchParams.get('re-authenticate');

  //handle re-authenticate
  useEffect(() => {
    if (!reAuthenticate || !isAuthNew) {
      return;
    }

    searchParams.delete('re-authenticate');
    login('redirect');
    setSearchParams(searchParams, { replace: true });
  }, [reAuthenticate, isAuthNew, login]);

  //handle auth error
  useEffect(() => {
    if (auth.error) {
      showToast({
        message: translations.something_wrong_try_again,
        position: isRtl ? 'left' : 'right',
        variant: 'error',
        showIcon: true,
      });
      datadogLogger(auth.error as unknown as Error, {
        description: 'Auth Error',
        errorSource: 'in AuthObserver.tsx',
      });
    }
  }, [auth.error]);

  return null;
};

export default AuthObserver;
